/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card as CardMui, CardContent, Typography, Box, Tabs, Tab } from '@mui/material';
import { styled } from '@mui/styles';
import { colors } from '../../../../utils';
import { Flex, MHeading } from '../../../../styledComponents';
import Card from '../../../../components/layout/Card';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Users from './pages/Users';
import ButtonCom from '../../../../components/button/ButtonCom';
import Profile from './pages/Profile';

const styles = {
    heading: {
        padding: '5px', // Adjust padding as needed
        marginTop: '20px', // Adjust margin as needed
        // backgroundColor: "#d8f2dc",
        background:'linear-gradient(to right, rgba(255,255,255,1) 23%, #d8f2dc 42%, #d8f2dc 57%, rgba(255,255,255,1) 77%)'
       , display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },

};


const CompanyTabs = () => {
    const dispatch = useDispatch();
    const { colorWhite, colorPrimary, colorSecondary } = colors;
    const location = useLocation();
    const navigate = useNavigate();
    const [value, setValue] = useState('Profile');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [companyDetails, setCompanyDetails] = useState(location.state.rowData);

    useEffect(() => {
        if (!companyDetails) {
            navigate(-1);
        }
    }, []);
    return (
        <>
            <Card margin='3rem 1.5rem' padding='3rem'>

                <ButtonCom btnTitle='Go Back' onClickHandler={() => navigate(-1)} />

                <Box style={styles.heading}>

                    <MHeading
                        className='font-face-M'
                        fs='2rem'
                        mb768='4rem'
                        align="center"
                    >
                        {companyDetails.company_name}
                    </MHeading>
                </Box>
                <Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
                    <Box
                        sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}

                    >
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            aria-label="Vertical tabs example"
                            sx={{ borderRight: 1, borderColor: 'divider', '& .MuiTab-root': { fontWeight: 600, fontFamily: "Poppins", fontSize: 12 } }}
                        >
                            <Tab label="Profile" value="Profile" />
                            <Tab label="Users" value="Users" />
                            {/* <Tab label="News" value="News" />
                            <Tab label="Contact" value="Contact" />
                            <Tab label="Configuration" value="Configuration" /> */}
                        </Tabs>

                        {value === 'Profile' && (
                            <Profile companyDetails={companyDetails} />
                        )}
                        {value === 'Users' && (
                            <Users companyDetails={companyDetails} />
                        )}
                        {/* {value === 'News' && (
                            <h1>News</h1>
                        )} */}

                    </Box>
                </Flex>
            </Card>
        </>
    );
};

export default CompanyTabs;
